// Ensure that the Percept SDK is initialized when your app is ready
function initializePercept() {
  // Initialize the Percept SDK with token
  window.percept.init("9a7fea48be13e0e5d83de4555f654b79e6ccdb4ad75120ec0ec200637020b880");
 
  // Clear the Percept SDK when the app is unmounted
  window.addEventListener("beforeunload", function () {
    window.percept.removeGlobalProperty("Page Title");
    window.percept.removeGlobalProperty("page_type");
    // window.percept.clear();
  });
}
// Add global user id
actOnUser = function (retry, func) {
  if (ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.user) {
    const uniqueUserId = ShopifyAnalytics.lib.user().traits().uniqToken;
    percept.setUserId(uniqueUserId);
    initializePercept();
 
    if (ShopifyAnalytics.lib.trekkie.defaultAttributes) {
      percept.setGlobalProperty(
        "Currency",
        ShopifyAnalytics.lib.trekkie.defaultAttributes.currency
      );
      percept.setGlobalProperty(
        "contentLanguage",
        ShopifyAnalytics.lib.trekkie.defaultAttributes.contentLanguage
      );
      percept.setGlobalProperty(
        "visitId",
        ShopifyAnalytics.lib.trekkie.defaultAttributes.visitToken
      );
    }
 
    if (ShopifyAnalytics.meta.page.customerId) {
      percept.setGlobalProperty(
        `customer_id`,
        ShopifyAnalytics.meta.page.customerId
      );
    } else {
      percept.removeGlobalProperty(`customer_id`);
    }
 
    if (ShopifyAnalytics.meta.page.pageType) {
      percept.setGlobalProperty(
        `page_type`,
        ShopifyAnalytics.meta.page.pageType
      );
    } else {
      percept.removeGlobalProperty(`page_type`);
    }
  } else {
    if (retry > 0) {
      setTimeout(function () {
        func(retry - 1, func);
      }, 100);
    }
  }
};
 
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    actOnUser(10, actOnUser);
  }, 1000);
});
